import { render, staticRenderFns } from "./AyudaMovimientoInterno.vue?vue&type=template&id=6bf4e14e&scoped=true"
import script from "./AyudaMovimientoInterno.vue?vue&type=script&lang=js"
export * from "./AyudaMovimientoInterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4e14e",
  null
  
)

export default component.exports